// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__YlHpV","upload":"Small_upload__1iVcN","imageWrap":"Small_imageWrap__1uxI4","removeBtn":"Small_removeBtn__3u-RT"};